import { push as pushRoute } from 'connected-react-router';

import {
    put, select, takeLatest,
} from 'redux-saga/effects';

import { extractQueryParameters, buildQueryParameters } from 'helpers/RoutesHelpers';
import Routes from '../constants/Routes';

import {
    getLocationSelector,
    getPathnameSelector,
} from '../../commons/selectors/RouterSelector';


import {
    OPEN_MODAL,
} from '../reduxModules/App';

export function* callAction(action) {
    const { message } = action.payload;
    const location = yield select(getLocationSelector);
    const searchParameters = extractQueryParameters(location.search);
    const pathname = yield select(getPathnameSelector);
    const params = {
        ...searchParameters,
        'support-modal': message ? Routes.CONTACT_SALESMAN.link : Routes.HOME_PAGE.link,
        message,
    };
    if (!params.message) {
        delete params.message;
    }
    const queryParams = buildQueryParameters(params);
    yield put(pushRoute(`${pathname}?${queryParams}`));
}

export function* watch() {
    yield takeLatest(OPEN_MODAL, callAction);
}
